<template>
  <div>
    <div
      class="description"
      :class="{ description__masked: masked }"
      ref="description"
      v-html="description"
    ></div>
    <button
      type="button"
      class="button button--invert description__unmask-button"
      v-if="initialized && masked"
      @click="unMask"
    >
      Læs mere
    </button>
  </div>
</template>

<script>
import { nextTick } from 'vue'

export default {
  data() {
    return {
      initialized: false,
      masked: true,
    }
  },
  components: {},
  props: {
    description: { default: '', type: String },
  },
  methods: {
    unMask() {
      this.masked = false
    },
  },
  mounted() {
    nextTick(() => {
      this.masked = this.$refs.description.scrollHeight > 200
      this.initialized = true
    })
  },
}
</script>

<style lang="scss">
@import 'Description.scss';
</style>
